import { SITE } from "@/config/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-ink">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="flex flex-col md:flex-row justify-between gap-12">
          <div className="max-w-sm">
            <span className="font-display italic text-3xl text-white">{SITE.coach}</span>
            <p className="font-mono text-[10px] tracking-[0.4em] text-burgundy uppercase mt-1">{SITE.brand}</p>
            <p className="text-slate-400 text-sm mt-6 leading-relaxed">
              Building the skills and confidence to become a successful
              investrader. Based in Singapore, coaching a global cohort.
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Navigate</span>
            {[["About", "#about"], ["Method", "#method"], ["Modules", "#modules"], ["Pricing", "#pricing"], ["Apply", "#enquire"]].map(([l, h]) => (
              <a key={h} href={h} className="text-slate-300 hover:text-burgundy text-sm transition-colors duration-300">{l}</a>
            ))}
          </div>

          <div className="flex flex-col gap-3">
            <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">Contact</span>
            <a href={`mailto:${SITE.email}`} className="text-slate-300 hover:text-burgundy text-sm transition-colors duration-300">{SITE.email}</a>
            <a href={SITE.whatsapp} target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-burgundy text-sm transition-colors duration-300">WhatsApp</a>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-slate-600 text-xs">© {new Date().getFullYear()} {SITE.coach} — Wealth × Coach. All rights reserved.</p>
          <p className="text-slate-600 text-xs max-w-lg md:text-right">
            Educational content only. Investing involves risk; results are not
            guaranteed and depend on individual effort and market conditions.
          </p>
        </div>
      </div>
    </footer>
  );
}
